'use es6';

import { OrderedSet } from 'immutable';
import createDSAdapter from './createDSAdapter';
import defaultAdapters from './defaultAdapters';
import invariant from 'react-utils/invariant';
export default ((...customAdapters) => {
  const adapters = OrderedSet.of(...customAdapters, ...defaultAdapters);
  const getFetcherFromProps = (assetFamily, props) => {
    const supportedAdapter = adapters.find(adapter => adapter.isAssetFamilySupported(assetFamily));
    invariant(supportedAdapter, `Adapter not provided for asset family: ${assetFamily}`);
    return supportedAdapter.getFetcherFromProps(assetFamily, props);
  };
  const fetch = (fetcher, variables, assetFamily, callback) => {
    const supportedAdapter = adapters.find(adapter => adapter.isAssetFamilySupported(assetFamily));
    invariant(supportedAdapter, `Adapter not provided for asset family: ${assetFamily}`);
    return supportedAdapter.fetch(fetcher, variables, assetFamily, callback);
  };
  const updater = (newData, prevData, assetFamily) => {
    const supportedAdapter = adapters.find(adapter => adapter.isAssetFamilySupported(assetFamily));
    invariant(supportedAdapter, `Adapter not provided for asset family: ${assetFamily}`);
    return supportedAdapter.updater(newData, prevData, assetFamily);
  };
  const isAssetFamilySupported = assetFamily => adapters.some(adapter => adapter.isAssetFamilySupported(assetFamily));
  return createDSAdapter({
    __adapters: adapters,
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
});